import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/data/services";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#F5C518] font-bold mb-3">
            // FAQ
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl uppercase tracking-tighter">
            Straight <span className="text-[#F5C518]">answers.</span>
          </h2>
          <p className="mt-3 text-sm text-neutral-400">
            The questions our high-value clients ask before they trust us with their vehicle.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-white/8 rounded-xl bg-white/[0.02] data-[state=open]:border-[#F5C518]/40 data-[state=open]:bg-[#F5C518]/[0.04] transition-colors px-5"
            >
              <AccordionTrigger className="font-display font-bold text-base uppercase tracking-tight text-left hover:no-underline py-5 [&[data-state=open]>svg]:text-[#F5C518]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-neutral-300 leading-relaxed pb-5 pt-0">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
